<template>
    <div class="form-group">
        <label :for="id.ID()" :class="{'sr-only': srOnly}">
            <slot name="label">{{ label }}</slot>
        </label>
        <textarea
            class="form-control"
            :class="{ 'is-invalid' : error }"
            :id="id.ID()" 
            :placeholder="placeholder"
            :value="value"
            @input="$emit('input', $event.target.value)"
            :rows="rows ? rows : 6"
            :aria-label="label"
        />
    </div>
</template>

<script>
import id from 'src/modules/uuid.js'

export default {
    props: {
        value: String,
        label: {
            type: String,
            required: true,
        },
        srOnly: {
            type: Boolean,
            default: false,
        },
        placeholder: String,
        rows: [String, Number],
        error: Boolean,
    },
    data() {
        return {
            id: new id()
        }
    }
}
</script>